import React, { useEffect, useState } from 'react'
import PendingAdItem from '../PendingAdItem/PendingAdItem'
import { setting } from "../../Common/setting"
import Slider from 'react-slick'
import "./AdminInfoCard.css"


import { useDispatch,useSelector } from 'react-redux'
import { fetchAds } from '../../features/Admin/AdminAction'
import {fetchCategories} from '../../features/Books/BooksAction'

import UserApi from '../../Common/Api/UserApi'
import Cookies from "js-cookie";
import ViewBooksAdmin from '../ViewBooksAdmin/ViewBooksAdmin'
import ViewAdmins from '../ViewAllAdmins/ViewAdmins'

export default function AdminInfoCard() {
  
  const dispatch = useDispatch();

  const {BookWormAdmin,Books} = useSelector((state)=>{
    return (state);
  })
  
  const {categories} = Books;
  
  const {pendingAds , rejectedAds, acceptedAds } = BookWormAdmin;

  const [notifications,setNotifications] = useState([...acceptedAds,...rejectedAds]);

  useEffect(() => {
  
    dispatch(fetchAds(1));
    dispatch(fetchCategories(1));
    console.log("fetching admin ads : ",BookWormAdmin)

    setNotifications(notifications.filter((ele)=>(ele.approved!==true)))

  },[])

  const [currentPage,setCurrentPage] = useState(1);

  const [addCategoryModal,setAddCategoryModal] = useState(false);
  const [categoryName,setCategoryName] = useState('');

  const changeCategoryName=(e)=>{
    e.preventDefault();

    setCategoryName(e.target.value)
    
  }
  const handleCategory = async()=>{

    const data = await UserApi.post(`admin/categories/add`,{
        categoryName:categoryName
      },{
          headers: {
              'Authorization': `Bearer ${Cookies.get('token')}`
          }
    })
    setAddCategoryModal(false)
    dispatch(fetchCategories(1));
  }

  const [removeModal,setRemoveModal] = useState(false);
  const [currCategory,setCurrCategory] = useState('');

  const deleteCategory=async()=>{

    const res = await UserApi.delete(`admin/categories/delete`,{
      categoryId:currCategory
    },{
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
    
    console.log(res);
    dispatch(fetchCategories(1));
    setRemoveModal(false);

  }

  return (
    <div className='AdminInfoCard'>
      <div className="AdminBtns">
        
        <button className={(currentPage==1)?"btn viewAdBtn selected-btn":'btn viewAdBtn'} onClick={()=>{ setCurrentPage(1) }} >View All Ad Request</button>
        <button className={(currentPage==2)?"btn viewAdBtn selected-btn":'btn viewAdBtn'} onClick={()=>{ setCurrentPage(2)}}>Pending Notifications</button>
        <button className={(currentPage==3)?"btn viewAdBtn selected-btn":'btn viewAdBtn'} onClick={()=>{ setCurrentPage(3)}}>Categories</button>
        <button className={(currentPage==4)?"btn viewAdBtn selected-btn":'btn viewAdBtn'} onClick={()=>{ setCurrentPage(4) }}>View All Books</button>
        <button className={(currentPage==5)?"btn viewAdBtn selected-btn":'btn viewAdBtn'} onClick={()=>{ setCurrentPage(5) }}>View Admins</button>

      </div>
      {(currentPage==1) && <div className='req-container all-ads'>
            <h2>Ad Requests for admin</h2>
          {
          (pendingAds.length === 0 ?
            <h3 style={{ color: "#fae5df" }}>No Pending Ad Requests</h3>
            : '') 
           }
            {(pendingAds.length <=3)? <div className='row' >
                    {
                       pendingAds.length? pendingAds.map((element) => {
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12 my-2'>
                            <PendingAdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} id={element._id}/>
                        </div>
                         
                        )}):''
                    }
                </div>:

                <Slider {...setting}>
                  {
                      pendingAds.map((element) => {
                          return (
                              <PendingAdItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} id={element._id}/>
                      )})
                  }
                </Slider>
                }
              
      </div>}

      {(currentPage==2) && <div className='req-container notifications'>
            <h2>Pending Notifications</h2>
             {
          (notifications.length === 0 ?
            <h3 style={{ color: "#fae5df" }}>No Pending Notification</h3>
            : '') 
           }
            {(notifications.length <=3)? 
                <div className='row'>
                  {console.log("Notifications array in admin notifi: ",notifications)}
                    {
                        notifications.map((element) => {
                       
                        return (

                        <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12 my-2'>
                            <PendingAdItem  name={element.title} img={element.images[0]} accepted = {element.accepted} isAdmin={true} id={element._id}/>
                        </div>
                         
                        )})
                    }
                </div>:

                <Slider {...setting}>
                {
                    notifications.map((element) => {
                     
                        return (
                            <PendingAdItem  name={element.title} img={element.images[0]} isAdmin={true} accepted={element.accepted} id={element._id}/>
                    )})
                }
                </Slider>
              }
      </div>}
      {(currentPage==3) && <div className='req-container'>

              <h2>Categories on Webssite :</h2>
               {
                (
                  categories.length === 0 ?
                  <h3 style={{ color: "#fae5df" }}>No Categories Found</h3>
                  : ''
                ) 
              }
              <div className='category-display'>
              {
                categories.map((element)=>{
                    return (
                      <div className='category-display-btn mx-2 my-2' style={{display:'inline'}} >
                        
                        <span style={{marginRight:'10px'}}>
                          {element.name}
                        </span>
                        
                        <i className="fa-solid fa-trash-can" style={{cursor:'pointer'}} onClick={()=>{setRemoveModal(true); setCurrCategory(element._id)}}></i>

                      </div>
                    )
                })
              }
              </div>

              <button className='add-category-button' onClick={()=>setAddCategoryModal(true)}>Add Category</button>
            
      </div> }

      {
        (currentPage===4) &&  <ViewBooksAdmin/>

      }

      {
        (currentPage==5) && <ViewAdmins/>
      }

      {/* MODAL */}
      {addCategoryModal && <div className='Modal'>
            <div className='modal-container' style={{width:"30vw"}}>
                <i className="fa-solid fa-xmark edit-close" onClick={()=>setAddCategoryModal(false)}></i>
                <h4>Enter the Category Name</h4>
                <input type="text" name='categoryName' value={categoryName} onChange={changeCategoryName}/>
                <button onClick={handleCategory}>Add Category</button>
            </div>
      </div>}

      {removeModal && <div className='Modal'>
          <div className='modal-container'>
              <i className="fa-solid fa-xmark edit-close" onClick={()=>setRemoveModal(false)}></i>
              <h4>Are you sure you want to remove this Category from Site?</h4>
              
              <button onClick={deleteCategory}>Confirm</button>
          </div>
      </div>}

    </div>
  )
}
